<template>
  <div class="c-navi">
    <div class="c-left"  @click="onClickClose"><a-icon type="close" /></div>
    <div class="c-center">{{title}}</div>
    <div class="c-right">
      <div class="save" v-if="rightBtn" @click="onClickSave">{{$t('actionTitles.save')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type: String,
    },
    rightBtn:{
      type: Boolean,
      default: true
    }
  },
  methods: {
    onClickClose() {
      this.$emit("onClickClose")
    },
    onClickSave() {
      this.$emit("onClickSave")
    }
  },
};
</script>

<style lang="less" scoped>
.c-navi {
  height: 44px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  /*background: linear-gradient(to top, #ccc .5px, transparent 0);*/
  /*font-size: 12px;*/
  border-bottom: 1px solid rgba(0,0,0,.1);
  box-shadow: 0 1px 1px 0 rgba(255,255,255,.08);
  .c-left {
    width: 70px;
    font-size: 16px;
  }
  .c-center {
    flex: 1;
    text-align: center;
  }
  .c-right {
    width: 70px;
    display: flex;
    justify-content: flex-end;
    .save {
      height: 26px;
      line-height: 26px;
      width: 60px;
      font-size: 12px;
      text-align: center;
      background-color: #ffffff;
      color: #666666;
      border-radius: 2px;
    }
  }
}
</style>